import React from 'react';

import { useTranslation } from 'react-i18next';

import ContactUsCard from './sections/ContactUsCard/ContactUsCard';
import DirectAccess from './sections/DirectAccess/DirectAccess';
import InteractiveCard from '../../../shared/components/v3/Cards/InteractiveCard/InteractiveCard';
import { HAPPY_BUDDY, OUT_WHITE_ICON } from '../../../shared/constants/images';
import { TRANSLATIONS_HOME } from '../../../shared/translations/home';

import './EmptyHome.scss';

const EmptyHome = () => {
  const { t } = useTranslation();

  const redirectToHelpCenter = () => {
    window.open('https://intercom.help/betterfly-support/es/', '_blank', 'noopener');
  };

  return (
    <div className="empty-home-container">
      <div className="first-component">
        <DirectAccess />
      </div>
      <div className="second-component">
        <InteractiveCard
          title={t(TRANSLATIONS_HOME.emptyHome.learnMoreCard.title)}
          description={t(TRANSLATIONS_HOME.emptyHome.learnMoreCard.description)}
          illustration={HAPPY_BUDDY}
          iconButton={OUT_WHITE_ICON}
          iconPosition="top"
          action={redirectToHelpCenter}
        />
      </div>
      <div className="third-component">
        <ContactUsCard />
      </div>
    </div>
  );
};

export default EmptyHome;
